import React, {useState} from 'react'
import ContractorsPage from '../modules/contractors/contractors-page.component'
import PhysiciansPage from '../modules/physicians/physicians-page.component'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PatientsPage from '../modules/patients/patients-page.component';
import AgentsPage from '../modules/agents/agents-page.component';



interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box >
             {children}
             
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
      sx: {
          fontFamily: 'Lato, sans-serif',
          fontWeight: 'bold',
           
      }
    };
  }
  

const Deleted = () => {
    const [value, setValue] = React.useState(0);
    const [numAgents, setNumAgents] = useState(0);

    const [numPhysicians, setNumPhysicians] = useState(0);
    const [numContractors, setNumContractors] = useState(0);
    const [numPatients, setNumPatients] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };
    return (
        <Box sx={{ width: '100%' }}>
          <Box sx={{borderBottom: 1, borderColor: 'divider', }} alignContent={'center'} alignItems={'center'} display="flex" justifyContent={'center'}>
      <Box sx={{ maxWidth: 500 }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"  textColor="inherit"
          variant="fullWidth">
                      <Tab label={`Patients(${numPatients})`} {...a11yProps(0)} />

          <Tab label={`Physicians(${numPhysicians})`} {...a11yProps(1)} />
          <Tab label={`Contractors(${numContractors})`} {...a11yProps(2)} />
          <Tab label={`Agents(${numAgents})`} {...a11yProps(2)} />
        </Tabs>
      </Box>
      </Box>
      <TabPanel value={value} index={0}>
       <PatientsPage Status={{
         '!=': 1
       }} onLoad={setNumPatients} />
      </TabPanel>
      <TabPanel value={value} index={1}>
       <PhysiciansPage  crieteria={{
         Status: {
          '!=': 1
         }
       }} onLoad={setNumPhysicians} />
      </TabPanel>
      <TabPanel value={value} index={2}>
      <ContractorsPage crieteria={{
         Status: {
          '!=': 1
         }
       }}   onLoad={setNumContractors} />
      </TabPanel>
      <TabPanel value={value} index={3}>
       <AgentsPage Status={{
         '!=': 1
       }} onLoad={setNumAgents} />
      </TabPanel>
    </Box>
    )
}

export default Deleted;
